import React, { useEffect, useState } from 'react';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import __isEmpty from 'lodash/isEmpty';

import { findUser, compUserAcount } from '../../services/parse';
import '../../lib/css/react-notifications.css';
import './MinervaLookup.css';
import PageHeader from '../../components/global/PageHeader';
import AccessCodePopup from '../../components/elements/AccessCodePopup';

function MinervaLookup() {
  const [email, setEmail] = useState();

  useEffect(() => {
    sessionStorage.setItem('hasAuthorization', 'isNotValid');
  }, []);

  const userLookup = (e) => {
    e.preventDefault();
    console.log('hasAuthorization', sessionStorage.getItem('hasAuthorization'));

    // if someone circumnavigates the access code page, then we can still prevent them from using this
    if (sessionStorage.getItem('hasAuthorization') === 'isNotValid') {
      NotificationManager.error('Sorry there seems to be an issue with your authorization. Please refresh the page and try again', '', 5000);
      return;
    }

    if (__isEmpty(email)) {
      NotificationManager.error('Please enter a valid email address', '', 5000);
      return;
    }

    const params = {
      fieldName: 'email',
      fieldValue: email
    };

    findUser(params).then((user) => {
      if (!user) {
        NotificationManager.error('There is no account associated with this email address. Please try a different email', '', 5000);
        return;
      } else {
        setupUserComp(user.id);
      }
    }).catch((error) => {
      NotificationManager.error('Oops, there seems to be a problem. Please try again.', '', 5000);
      console.error('Minerva error during account lookup', error);
    });
  }

  const setupUserComp = (userId) => {
    compUserAcount(userId).then((results) => {
      console.log('results', results);
      setEmail('');
      NotificationManager.success('Student account found and properly set up! Student should now be able to access the app', '', 8000);
    }).catch((error) => {
      NotificationManager.error('We are unable to access the account for this student at this time. Please try again later.', '', 5000);
      console.error('Minerva error during comping', error);
    });
  }

  return (
    <div className="minerva-lookup-container page">
      <AccessCodePopup />
      <PageHeader text="codeSpark Classroom User Lookup Tool" />
      <form className="lookup-form" onSubmit={(e) => userLookup(e)}>
        <div className="input-fields">
          <label>Student email:</label>
          <div className="textbox">
            <input
              type="email"
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              defaultValue={email}
            />
          </div>
        </div>
        <div className="submit-button">
          <button onClick={(e) => userLookup(e)}>
            Lookup User
          </button>
        </div>
        <NotificationContainer />
      </form>
    </div>
  )
}

export default MinervaLookup;


// WEBPACK FOOTER //
// ./src/containers/MinervaLookup/index.js